import React from "react";
import PropTypes from "prop-types";
import Spinner from "react-webpack-spinner";
import { FaEdit, FaArrowLeft, FaRoute } from "react-icons/fa";

import InstitutionDetailsInner from "./InstitutionDetailsInner";

class ViewInstitution extends React.Component {
  componentWillMount() {
    const { institution_key, onLoadEntry } = this.props;
    onLoadEntry(institution_key);
  }

  render() {
    const { institution, onClose, onEditInstitution, mayEdit } = this.props;
    const { street, zipcode, city } = institution.address || {};
    return (
      <div className="content">
        {institution._key ? (
          <InstitutionDetailsInner institution={institution} showAll={true} />
        ) : (
          <div className="flex-1-1 has-text-centered">
            <Spinner width={32} height={32} color="#000" />
          </div>
        )}
        {institution._key && (
          <button
            className="button is-info is-medium"
            onClick={onClose}
            title="zurück"
          >
            <FaArrowLeft className="is-small" />
          </button>
        )}

        {mayEdit && institution._key && (
          <button
            onClick={() => onEditInstitution(institution._key)}
            className="button is-info is-medium"
            title="Bearbeiten"
          >
            <FaEdit className="is-small" />
          </button>
        )}

        {street && (
          <a
            title="Mit Google navigieren"
            target="_blank"
            className="button is-medium is-info"
            href={`http://maps.google.com/maps?daddr=${street} ${zipcode} ${city}`}
          >
            <FaRoute />
          </a>
        )}
      </div>
    );
  }
}

ViewInstitution.propTypes = {
  institution: PropTypes.object.isRequired
};

export default ViewInstitution;



/** WEBPACK FOOTER **
 ** ./src/components/ViewInstitution.jsx
 **/